import { render, staticRenderFns } from "./evolucionPerfil.vue?vue&type=template&id=42aed5a3"
import script from "./evolucionPerfil.vue?vue&type=script&lang=js"
export * from "./evolucionPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports